import React, { Component } from 'react';

export const AUTH = { 
    domain:  'triciclogo.us.auth0.com',
    client_id: 'xafz9QS2p3NPrnEYqAiaqwPvlA5hvXE2',
    response_type: 'token id_token',
    audience: "https://app.triciclogo.com/api/",
    socpe: 'openid profile email read:customers create:customers update:customers'
};

class Config extends Component {
}

export default Config;